import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesDespublicar.vue?vue&type=template&id=13e96ff3&scoped=true"
import script from "./LicitacaoAtualizacaoAcoesDespublicar.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesDespublicar.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoAtualizacaoAcoesDespublicar.vue?vue&type=style&index=0&id=13e96ff3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e96ff3",
  null
  
)

export default component.exports